import React, { useEffect, useMemo, useState } from "react";
import pdfIcon from "../../../images/pdfIcon.png";
import { isPdf } from "../../../services/Functions";
import { normalizeImageSrc } from "./mrcReadingUtils";

/**
 * Evidence thumbnail: never leave PDF bytes in <img src>.
 * Detected PDFs (and failed image loads) show the red PDF icon.
 */
export default function MrcEvidencePreview({
  src,
  alt = "Evidence",
  className = "",
  pdfClassName = "mrc-meter-image-preview__pdf",
  photoClassName = "mrc-meter-image-preview__photo",
}) {
  const [forcePdf, setForcePdf] = useState(false);

  const normalized = useMemo(() => {
    if (!src || typeof src !== "string") return "";
    return normalizeImageSrc(src) || src;
  }, [src]);

  useEffect(() => {
    setForcePdf(false);
  }, [normalized]);

  if (!normalized) return null;

  if (forcePdf || isPdf(normalized) || isPdf(src)) {
    return (
      <img
        className={`${pdfClassName} ${className}`.trim()}
        src={pdfIcon}
        alt="PDF"
      />
    );
  }

  return (
    <img
      className={`${photoClassName} ${className}`.trim()}
      src={normalized}
      alt={alt}
      onError={() => setForcePdf(true)}
    />
  );
}
